module.exports = __webpack_public_path__ + "img/playMarket.9c40e0c3.svg";